import * as React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import autobind from 'autobind-decorator';

export interface IVideoVoteProps {
  upvotes: number;
  downvotes: number;
  addMarker: any;
  updateSeek: any;
}
export interface IVideoVoteState {
}

export default class VideoVote extends React.Component<IVideoVoteProps, IVideoVoteState> {
  constructor(props: IVideoVoteProps) {
    super(props);

    this.state = {
    }
  }

  @autobind
  public handleOnChange(event) {
    event.preventDefault();
    event.stopPropagation();
    let time = event.target.value.trim();
    time = time.split(':');
    if (time.length === 2) {
      time = parseInt(time[0]) * 60 + parseInt(time[1]);
      this.props.updateSeek(time);
    }
  }
  public render() {
    return (
      <Row>
        <Col md={4}>
          <input name="time" type="time" defaultValue="00:00"
            onChange={this.handleOnChange} className="form-control form-marker-time" />
        </Col>
        <Col md={{ span: 2 }}>
          <Button variant='light' onClick={this.props.addMarker}>
            Add Quiz/Marker
          </Button>
        </Col>
        <Col md={{ span: 2, offset: 2 }}>
          <span style={{ color: "green" }}>Upvotes:{this.props.upvotes}</span>
        </Col>
        <Col md-span={2}>
          <span style={{ color: "red" }}>Downvotes:{this.props.downvotes}</span>
        </Col>
      </Row>
    );
  }
}
